// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const cn = {
  subscriptionsDrawer: {
    canceledBy: {
      subscriber: `由订阅者取消`,
      producer: `由创作者取消`,
      api: `由集成（API）取消`,
      system: `由 Cakto 取消`,
    },
    cancellationReason: `原因：{{reason}}`,
  },
  demo: {
    title: `Chinese`,
    introduction: `Lorem Ipsum 只是印刷和排版行业的虚拟文本。 自 1500 年代以来，Lorem Ipsum 一直是行业的标准虚拟文本，当时一位不知名的印刷商采用了一种类型的厨房并将其加扰以制作类型样本书。 它不仅经历了五个世纪，而且经历了电子排版的飞跃，基本保持不变。 它在 1960 年代随着包含 Lorem Ipsum 段落的 Letraset 表的发布而流行起来，最近还随着 Aldus PageMaker 等桌面出版软件（包括 Lorem Ipsum 的版本）而普及.`,
  },
  docs: {
    hi: `你好`,
    description: `需要帮忙？\n 请查看我们的文档.`,
    documentation: `文件`,
  },
  languages: {
    pt: `葡萄牙语（巴西）`,
    en: `英语`,
    es: `西班牙语`,
    cn: `中文`,
  },
  pagination: {
    previousPage: `上一页`,
    nextPage: `下一页`,
  },
  app: `应用程序`,
  user: `用户`,
  list: `列表`,
  edit: `编辑`,
  shop: `商店`,
  blog: `博客`,
  post: `邮政`,
  mail: `电子邮件`,
  chat: `聊天`,
  cards: `牌`,
  posts: `帖子`,
  create: `创建`,
  kanban: `登机`,
  general: `一般的`,
  banking: `银行业`,
  booking: `预订`,
  profile: `轮廓`,
  account: `帐户`,
  product: `产品`,
  invoice: `发票`,
  details: `细节`,
  checkout: `退房`,
  calendar: `日历`,
  analytics: `分析`,
  ecommerce: `电子商务`,
  management: `管理`,
  menu_level: `菜单级别`,
  menu_level_2a: `菜单级别 2a`,
  menu_level_2b: `菜单级别 2b`,
  menu_level_3a: `菜单级别 3a`,
  menu_level_3b: `菜单级别 3b`,
  menu_level_4a: `菜单级别 4a`,
  menu_level_4b: `菜单级别 4b`,
  item_disabled: `项目已禁用`,
  item_label: `项目标签`,
  item_caption: `项目标题`,
  item_external_link: `项目外部链接`,
  description: `描述`,
  other_cases: `其他情况`,
  item_by_roles: `按角色逐项`,
  only_admin_can_see_this_item: `只有管理员可以看到这个项目`,
  ratingSurvey: {
    logoAlt: `Cakto 标志`,
    pageTitle: `我们想听听您的意见！`,
    pageSubtitle: `您的反馈帮助我们持续改进产品。`,
    satisfactionQuestion: `您对该产品的满意度如何？`,
    commentLabel: `能告诉我们您给出该评分的原因吗？`,
    commentPlaceholder: `请在此输入您的回答...`,
    charCount: `{{count}}/500 个字符`,
    submit: `提交反馈`,
    submitting: `正在发送...`,
    errorGeneric: `无法提交评价，请重试。`,
    cactusLabels: {
      1: { line1: `非常`, line2: `不满意！` },
      2: { line1: `不满意`, line2: `` },
      3: { line1: `一般`, line2: `` },
      4: { line1: `满意！`, line2: `` },
      5: { line1: `非常`, line2: `满意！` },
    },
    validation: {
      ratingRequired: `请选择评分`,
      ratingMin: `请至少选择 1 个仙人掌`,
      ratingMax: `最多 5 个仙人掌`,
      commentRequired: `评论为必填项`,
      commentMin: `请更详细地描述您的体验（至少 10 个字符）`,
    },
    errorState: {
      expired: {
        title: `调查链接已过期`,
        messageBold: `调查在购买后最多开放 7 天。`,
        messageNormal: `这有助于反馈反映您最近的使用体验。您可在下次购买时再次参与。`,
      },
      already_used: {
        title: `评价已提交`,
        message: `您已为此商品提交评价。感谢您的反馈！`,
      },
      error: {
        title: `链接无效`,
        message: `此链接无效。请确认您已从邮件中完整复制链接。`,
      },
      goToPlatform: `前往平台`,
    },
  },
  subscriberFlow: {
    common: {
      logoAlt: `Cakto 标志`,
      loadError: {
        title: `加载失败`,
        description: `获取您的信息时出现问题。这并不代表您没有订阅。`,
        retry: `重试`,
      },
      backToSubscriptions: `我的订阅`,
      signOut: `退出`,
      price: `{{amount}}/{{interval}}`,
      interval: {
        monthly: `月`,
        yearly: `年`,
        weekly: `周`,
        everyNDays: `{{days}} 天`,
      },
      paymentMethod: {
        card: `信用卡`,
        cardWithDigits: `卡 •••• {{lastDigits}}`,
        automaticPix: `自动 Pix`,
        pix: `Pix`,
        boleto: `Boleto`,
      },
    },
    home: {
      title: `我的订阅`,
      description: `使用购买时填写的邮箱或手机号登录。无需密码，也无需重新注册 — 我们会发送验证码。`,
      identifierLabel: `购买时使用的邮箱或手机号`,
      identifierPlaceholder: `请输入邮箱或手机号（含区号）`,
      sendCode: `获取登录验证码`,
      comingSoon: `即将上线`,
      google: {
        signIn: `使用 Google 登录`,
        or: `或`,
        signingIn: `正在使用 Google 登录…`,
        notice: {
          noAccount: `未找到与该 Google 邮箱关联的账户或订阅。请输入购买时使用的邮箱或手机号。`,
          useCode: `该邮箱需通过验证码确认：请在下方输入邮箱。`,
          expired: `使用 Google 登录已过期，请重试。`,
          failed: `无法使用 Google 登录，请重试。`,
        },
      },
      link: {
        signingIn: `正在打开您的订阅…`,
        notice: {
          invalid: `此访问链接已过期或已失效。请使用购买时填写的邮箱登录以继续。`,
          failed: `暂时无法通过链接打开您的订阅。请使用购买时填写的邮箱登录以继续。`,
          sessionEnded: `通过链接开启的会话已结束。请重新打开通知中的链接，或使用购买时填写的邮箱登录。`,
        },
      },
      validation: {
        identifierRequired: `请填写购买时使用的邮箱或手机号`,
        identifierInvalid: `请填写有效的邮箱，或含区号的手机号`,
      },
      toast: {
        codeResent: `验证码已重新发送。`,
        codeResentEmail: `验证码已重新发送，请查看邮件。`,
        codeResentWhatsapp: `验证码已重新发送，请查看 WhatsApp。`,
      },
      errors: {
        sendCode: `验证码发送失败，请稍后重试。`,
        tooManyAttempts: `短时间内尝试次数过多，请等待一分钟后再试。`,
        phoneLoginUnavailable: `手机号登录暂不可用，请使用购买时的邮箱。`,
      },
    },
    verifyCode: {
      description: `我们已向 {{identifier}} 发送 6 位验证码。`,
      descriptionEmail: `我们已通过邮件向 {{identifier}} 发送 6 位验证码。`,
      descriptionWhatsapp: `我们已通过 WhatsApp 向 {{identifier}} 发送 6 位验证码。`,
      codeLabel: `验证码`,
      codePlaceholder: `000000`,
      submit: `登录`,
      changeIdentifier: `更换邮箱/手机号`,
      resendCode: `重新发送验证码`,
      resendCodeIn: `{{seconds}} 秒后可重新发送`,
      resendCodeLocked: `{{minutes}} 分钟后可重新发送`,
      lockOver: `等待已结束，请重新获取验证码后登录。`,
      validation: {
        codeInvalid: `请输入我们发送的 6 位验证码。`,
      },
      errors: {
        confirmCode: `验证码确认失败，请重试。`,
        wrongCode: `验证码无效或已过期，请检查验证码或重新获取。`,
        locked: `错误验证码尝试次数过多。为了您的安全，请等待 {{minutes}} 分钟后重新获取验证码。`,
      },
    },
    header: {
      loggedInAs: `当前会话`,
      linkAccess: `通过通知链接访问`,
      signInWithEmail: `使用邮箱登录`,
    },
    subscriptionsPage: {
      title: `我的订阅`,
      description: `管理付款方式并查看有效订阅。当前会话：{{identifier}} — 无需重新注册。`,
      descriptionLink: `您通过通知链接进入，只能看到这一个订阅。如需查看其他订阅，请使用购买时填写的邮箱登录。`,
      status: {
        active: `有效`,
        inactive: `未激活`,
        paymentPending: `待付款`,
        chargeProcessing: `扣款处理中`,
        canceled: `已取消`,
        expired: `已过期`,
        paused: `已暂停`,
        trial: `试用中`,
        late: `已逾期`,
      },
      caption: {
        active: `{{price}} · {{method}} · 下次扣款 {{nextChargeAt}}`,
        canceled: `{{price}} · {{method}} · 于 {{canceledAt}} 取消 · 后续扣款已停止`,
        canceledWithoutDate: `{{price}} · {{method}} · 已取消 · 后续扣款已停止`,
        paymentPending: `{{price}} · {{failedAt}} 未识别到付款`,
        paymentPendingWithoutDate: `{{price}} · 未识别到付款`,
      },
      pendingCallout: `本次扣款未通过。系统会自动重试 — 请在最后一次尝试（{{lastRetryAt}}）之前更新付款方式，以免因欠款被取消。`,
      pendingCalloutWithoutDate: `本次扣款未通过。系统会自动重试 — 请在最后一次尝试之前更新付款方式，以免因欠款被取消。`,
      pendingCalloutWithoutRetry: `本次扣款未通过，系统不会再自动重试。`,
      pendingCalloutPixRenewalExpired: `续订的 Pix 已过期，无法再支付。请选择支付方式以保留您的订阅。`,
      resolvedByAutomaticPixCallout: `自动 Pix 已授权。新的扣款正在处理 — 一旦通过，欠款即结清，状态将恢复为“有效”。`,
      actions: {
        resolveNow: `立即处理`,
        changePaymentMethod: `更换付款方式`,
        reactivate: `重新订阅`,
        viewHistory: `查看记录`,
        cancelSubscription: `取消订阅`,
        cancelNeedsEmail: `如需取消，请使用购买时填写的邮箱登录`,
      },
      empty: {
        title: `您还没有订阅`,
        description: `在 Cakto 订阅产品后，无论有效还是已结束，都会显示在这里，并附有状态、金额和下次扣款日期。`,
      },
      reactivateHint: `这会按当前报价的价格和条件创建一份新订阅。原订阅仍保持已结束状态。`,
      support: `需要帮助？请通过购买时提供的客服邮箱联系创作者。`,
      toast: {
        subscriptionCanceled: `订阅已取消。后续扣款立即停止。`,
        cancelFailed: `无法取消订阅。请重试或联系客服。`,
      },
    },
    cancelDialog: {
      title: `取消订阅`,
      description: `订阅 {{productName}} 将被取消，后续扣款立即停止。`,
      irreversible: `此操作无法撤销。之后如需恢复访问，需要按当前价格和条件重新订阅。`,
      inputLabel: `输入 {{phrase}} 以确认`,
      inputHelper: `为避免误取消，必须进行确认。`,
      keep: `保留订阅`,
      confirm: `确认取消`,
      confirmationPhrase: `取消订阅`,
      reasonLabel: `您为什么要取消？（可选）`,
      reasons: {
        preferNotToSay: `不想说`,
        tooExpensive: `太贵了`,
        notUsing: `我没有在用`,
        notAsExpected: `和我预期的不一样`,
        accessProblem: `访问出现问题`,
        other: `其他原因`,
      },
      errors: {
        alreadyCanceled: `该订阅已经取消。`,
        notCancelable: `该订阅目前无法在此取消。请通过购买时提供的客服邮箱联系创作者。`,
        notLinked: `我们找不到该订阅，无法取消。请通过购买时提供的客服邮箱联系创作者。`,
        cancelDisabled: `目前无法通过门户取消订阅。请稍后重试。`,
        cancelLateDisabled: `付款待处理期间，目前无法在此取消。请先处理付款，或稍后重试。`,
        invalidReason: `无法识别所选原因。请选择其他原因或"不想说"，然后重试。`,
        emailScopeRequired: `如需取消，请使用购买时的邮箱登录。`,
        unavailable: `目前无法取消，订阅未发生变化。请几分钟后重试。`,
        unconfirmed: `我们无法确认取消结果。重试前请先查看您的订阅列表。`,
        tooManyAttempts: `取消尝试次数过多。请稍候再试。`,
      },
    },
    paymentPage: {
      title: `更新付款方式`,
      contextPending: `{{productName}} · {{price}} · 自 {{failedAt}} 起待付款`,
      contextPendingWithoutDate: `{{productName}} · {{price}} · 待付款`,
      contextActive: `{{productName}} · {{price}} · 正常`,
      callouts: {
        recoveryEmail: `您是从催缴邮件进入的 — 这就是邮件中提到的待付款订阅。`,
        renewalReminder: `您是从续订提醒邮件进入的。您可以在此查看下次扣款的支付方式，并在续订前进行更改。`,
      },
      notFound: {
        title: `未找到订阅`,
        description: `在您的订阅中未找到该订阅。如果您是从邮件进入的，请使用该次购买时的邮箱或手机号登录。`,
        switchAccount: `使用其他邮箱或手机号登录`,
      },
      errors: {
        subscriptionNotLinked: `无法在此修改该订阅的付款方式。请通过购买时提供的客服邮箱联系创作者。`,
        subscriptionEnded: `该订阅已结束。如需继续，请重新订阅。`,
        pixPaymentPending: `您已为此笔扣款生成了 Pix。请支付该 Pix，或等待其过期后再使用其他支付方式。`,
        paymentMethodNotEnabled: `此订阅不支持该支付方式。请选择其他方式。`,
      },
      methods: {
        creditCard: `信用卡`,
        automaticPix: `自动 Pix`,
        pix: `Pix`,
      },
      card: {
        holderNameLabel: `持卡人姓名`,
        holderNamePlaceholder: `与卡片上印刷的一致`,
        numberLabel: `卡号`,
        numberPlaceholder: `0000 0000 0000 0000`,
        expirationLabel: `有效期`,
        expirationPlaceholder: `MM/YY`,
        cvvLabel: `CVV`,
        cvvPlaceholder: `000`,
        submitPending: `保存并重新扣款`,
        submitActive: `保存新卡`,
        footnote: `待付款项会立即在新卡上扣取。您的历史记录会保留。`,
        retry: `重试`,
        errors: {
          infrastructure: `目前无法处理扣款，请几分钟后再试。`,
          cardNotProcessed: `无法处理此卡，请检查卡信息或使用其他卡。`,
          issuerTimed: `发卡行暂时拒绝了扣款，例如额度或余额不足。请使用其他卡或稍后再试。`,
          issuer: `发卡行拒绝了此次扣款，请使用其他卡。`,
          notApproved: `扣款未获批准，请使用其他卡。`,
          chargeInProgress: `目前无法保存此卡。此订阅可能已有一笔扣款正在处理中：请先查看订阅状态再重试。`,
          unconfirmed: `无法确认换卡和扣款结果。请几分钟后查看订阅状态，再决定是否重试。`,
          tooManyAttempts: `尝试次数过多，请稍候再试。`,
          emailScopeRequired: `如需修改订阅，请使用购买时的邮箱登录。`,
          invalidCard: `请检查卡信息。`,
          generic: `无法保存此卡。`,
        },
        validation: {
          holderNameRequired: `请输入卡片上印刷的持卡人姓名。`,
          numberInvalid: `请输入卡号的 16 位数字。`,
          expirationFormat: `请使用 MM/YY 格式。`,
          expirationMonth: `月份无效，请使用 01 至 12。`,
          expirationExpired: `银行卡已过期，请使用有效期在未来的卡。`,
          cvvInvalid: `CVV 为 3 位数字，请查看卡片背面。`,
        },
      },
      automaticPix: {
        explanation: `自动 Pix 会在每个周期直接从您的账户扣取订阅金额，您无需操作。只需在银行 App 中授权一次。`,
        start: `在我的银行生成授权`,
        footnote: `迁移后，您以往的扣款记录会保留。`,
        waitingTitle: `等待您的银行确认`,
        waitingDescription: `请打开银行 App，扫描二维码并授权 {{productName}}（{{price}}）的自动 Pix。`,
        waitingPolling: `每 5 秒检查一次…`,
        waitingBack: `返回`,
        pollingExhausted: `我们尚未收到您银行的确认。如果您已授权，请稍等几分钟后刷新页面。`,
        generatingQr: `正在生成代码…`,
        pendingWithoutQr: `已有一个授权正在等待您的银行确认。`,
        applyingTitle: `银行已批准，正在应用变更`,
        applyingDescription: `您的银行已授权 {{productName}} 的自动 Pix。我们正在更换您订阅的付款方式，这需要片刻时间。`,
        applyingExhausted: `您的银行已批准。变更仍在应用中，请几分钟后再来查看。`,
        copyCode: `复制 Pix 代码`,
        codeCopied: `Pix 代码已复制。`,
        copyFailed: `无法复制代码。`,
        unavailable: {
          disabled: `自动 Pix 暂不可用，请使用信用卡。`,
          subscription: `该订阅不支持自动 Pix，请使用信用卡。`,
          alreadyActive: `该订阅已在使用自动 Pix。`,
          notDelinquent: `自动 Pix 需与一笔待付款项一起授权，而该订阅目前没有欠款。`,
        },
      },
      noMethods: `无法在此处支付该订阅。请通过购买时提供的客服邮箱联系创作者。`,
      pix: {
        generating: `正在生成 Pix…`,
        title: `使用 Pix 支付`,
        description: `打开您的银行 App，使用二维码或复制粘贴代码为 {{productName}} 支付 {{amount}}。`,
        expiresAt: `有效期至 {{expiresAt}}`,
        copyCode: `复制 Pix 代码`,
        codeCopied: `Pix 代码已复制。`,
        copyFailed: `无法复制代码。`,
        waitingPolling: `等待付款。每 5 秒检查一次…`,
        pollingExhausted: `我们尚未收到付款确认。`,
        checkAgain: `我已付款，再次检查`,
        expired: `此 Pix 已过期，无法再支付。请生成新的 Pix 进行支付。`,
        canceled: `此 Pix 已取消，无法再支付。请生成新的 Pix 进行支付。`,
        generateNew: `生成新的 Pix`,
        retry: `重试`,
        footnote: `您的订阅仍使用 Pix：后续续订也将通过二维码发送。`,
        errors: {
          notEnabled: `此订阅不支持 Pix。请选择其他支付方式。`,
          notDelinquent: `此订阅没有待支付的扣款：已是正常状态。`,
          chargeInProgress: `此订阅已有一笔扣款正在处理中。生成 Pix 前请先查看订阅。`,
          unavailable: `暂时无法生成 Pix。请几分钟后重试。`,
          generic: `无法生成 Pix。`,
        },
      },
      toast: {
        cardUpdated: `付款方式已更新。`,
        chargeProcessing: `新卡的扣款正在处理中，银行确认后订阅状态会随即更新。`,
        automaticPixAuthorized: `自动 Pix 已授权。`,
        automaticPixFailed: `无法创建授权，请重试。`,
        automaticPixRejected: `您的银行未授权自动 Pix，请重试或使用银行卡。`,
      },
    },
    historyPage: {
      title: `付款记录`,
      subtitle: `{{productName}} · {{price}}`,
      chargeStatus: {
        paid: `已通过`,
        refused: `已拒绝`,
        retrying: `重试中`,
        waitingPayment: `等待付款`,
        scheduled: `已排程`,
        refunded: `已退款`,
        chargedback: `拒付`,
        canceled: `已取消`,
        processing: `处理中`,
        authorized: `已授权`,
        refundRequested: `已申请退款`,
        inSettlement: `退款处理中`,
        acquirerError: `退款未完成`,
        blocked: `已拦截`,
        inProtest: `争议中`,
        partiallyPaid: `部分支付`,
        prechargeback: `争议审核中`,
        med: `审核中（MED）`,
      },
      detail: {
        firstCharge: `首次扣款`,
        coupon: `优惠券 {{code}}`,
        retry: `第 {{attempt}} 次重试`,
        settledAt: `{{paidAt}} 结清`,
      },
      footnote: `每次尝试都会记录，并在可获取时附上拒绝原因 — 不会有任何遗漏。`,
      empty: `该订阅暂无扣款记录。`,
    },
    successPage: {
      titleCard: `欠款已结清`,
      titleAutomaticPix: `自动 Pix 已授权`,
      titlePix: `付款已确认`,
      bodyCard: `系统已用新卡对 {{productName}} 重新扣款并通过。您的访问权限已保障，下次扣款为 {{nextChargeAt}}。`,
      bodyAutomaticPix: `我们已收到您银行的授权。系统正在对 {{productName}} 执行新的扣款 — 您无需再做任何操作。`,
      bodyPix: `我们已收到 {{productName}} 的 Pix 付款。您的访问权限已得到保障，下次扣款日期为 {{nextChargeAt}}。`,
      statusLabel: `订阅状态：`,
      back: `返回我的订阅`,
      footnote: `欠款已结清：重试流程已停止，下次扣款已重新计算，确认信息已通过邮件和 WhatsApp 发送，webhook 也已触发。`,
    },
  },
  refundFlow: {
    common: {
      logoAlt: `Cakto 标志`,
      back: `返回`,
      of: `的`,
    },
    headerPurchase: {
      loggedInAs: `您已登录：`,
      signOut: `退出登录`,
    },
    purchasesPage: {
      title: `我的订单`,
    },
    home: {
      title: `申请退款`,
      descriptionLine1: `您可以在购买后 7 天内申请退款。`,
      descriptionLine2: `申请退款后，您的订单将被取消，且无法继续访问该产品。`,
      identifierLabel: `购买时使用的邮箱或手机号`,
      identifierPlaceholder: `请输入您的邮箱或手机号（含区号）`,
      findPurchase: `查找您的订单`,
      google: {
        signIn: `使用 Google 登录`,
        or: `或`,
        signingIn: `正在使用 Google 登录…`,
        notice: {
          noAccount: `未找到与该 Google 邮箱关联的账户或订单。请输入购买时使用的邮箱或手机号。`,
          useCode: `该邮箱需通过验证码确认：请在下方输入邮箱。`,
          expired: `使用 Google 登录已过期，请重试。`,
          failed: `无法使用 Google 登录，请重试。`,
        },
      },
      validation: {
        identifierRequired: `请输入购买时使用的邮箱或手机号`,
        identifierInvalid: `请输入有效的邮箱地址或含区号的手机号`,
      },
      errors: {
        sendCode: `发送验证码时发生错误，请稍后重试。`,
      },
    },
    verifyEmail: {
      exit: `退出`,
      title: `验证您的邮箱`,
      titleWhatsapp: `验证您的 WhatsApp`,
      description: `如果邮箱 {{email}} 关联了订单，您将收到验证码。请在下方输入以继续。`,
      descriptionWhatsapp: `如果号码 {{phone}} 关联了订单，您将通过 WhatsApp 收到验证码。请在下方输入以继续。`,
      resendCode: `重新发送验证码`,
      continue: `确认验证码`,
      errors: {
        invalidOrExpiredToken: `验证码无效或已过期，请重新进行验证流程。`,
      },
    },
    purchase: {
      pageHeading: `申请退款`,
      pageSubtitle: `请核对购买信息并选择退款原因。标有必填的字段需要填写后才能继续。`,
      loadingDetails: `正在加载购买详情…`,
      loadError: `无法加载此购买信息，请检查网络后重试。`,
      retry: `重试`,
      orderNotFound: `未在您的列表中找到该购买，或您没有权限查看。`,
      orderNotFoundCta: `查看我的购买`,
      backNavAria: `返回购买列表`,
      backToRefundRequest: `申请退款`,
      productDetailsTitle: `产品详情`,
      refundReasonTitle: `退款原因`,
      selectReasonRequired: `请选择退款原因（必填）*`,
      otherReason: `其他原因`,
      explainLabel: `请用您的话说明`,
      explainPlaceholder: `请更详细地告诉卖家您申请退款的原因`,
      requestRefundButton: `申请退款`,
      installments: `{{installments}} 期，每期 {{amount}}`,
      fields: {
        productName: `产品名称`,
        amount: `金额`,
        purchaseDate: `购买日期`,
        refundDeadline: `申请退款截止日期`,
        paymentMethod: `支付方式`,
        supportEmail: `卖家支持邮箱`,
        producerName: `卖家名称`,
      },
      paymentMethods: {
        pix: `Pix`,
        creditCard: `信用卡`,
        ticket: `Boleto`,
        billet: `Boleto`,
        oxxo: `OXXO`,
        spei: `SPEI`,
        pixAuto: `Pix 自动扣款`,
        boleto: `Boleto`,
        debitCard: `借记卡`,
        pagaleveInstallments: `Pix 分 {{installments}} 期免息`,
        pagaleveUpfront: `Pix 一次性付清`,
        picpay: `PicPay`,
        googlepay: `Google Pay`,
        applepay: `Apple Pay`,
        paypal: `PayPal`,
        nubank: `Nubank`,
        mercadopago: `Mercado Pago`,
        pse: `PSE`,
        nequi: `Nequi`,
        safetypay: `SafetyPay`,
        unknown: `未知`,
      },
      refundReasons: {
        optionAccessIssue: `我还无法访问该产品，但我希望获得访问权限`,
        optionNeedMoney: `我需要把钱用于其他事情`,
        optionFilesNotOpening: `我已获得访问权限，但页面或文件无法打开`,
        optionNoSupportResponse: `卖家没有回复我的支持请求`,
        optionLowQuality: `产品质量未达到我的预期`,
        optionIncompleteProduct: `产品内容不完整`,
        optionDuplicatePurchase: `重复购买`,
      },
      bankInfo: {
        title: `退款银行信息`,
        descriptionRequired: `此笔付款以现金支付，因此我们需要您接收退款的银行账户。没有这些信息，我们无法完成退款。`,
        descriptionOptional: `如果您希望将退款汇入指定账户，请填写以下信息，也可以留空。`,
        fields: {
          clabe: `CLABE`,
          clabeHelper: `您的 CLABE 账户的 18 位数字`,
          bank_account_holder_name: `账户持有人姓名`,
          bank_account_holder_document: `持有人证件（CURP 或 RFC）`,
          bank_name: `银行`,
          bank_branch: `分行`,
          bank_account: `账号`,
          account_type: `账户类型`,
        },
        validation: {
          clabe: `CLABE 无效，请检查 18 位数字。`,
          maxLength: `长度超出允许范围`,
        },
      },
      validation: {
        required: `必填字段`,
      },
      errors: {
        requestRefund: `处理退款时发生错误，请直接联系卖家。`,
      },
    },
    successModal: {
      title: `退款已确认`,
      description: `我们已收到您的申请，正在处理中。`,
      deadlineTitle: `您将在 24 小时内收到退款`,
      deadlineDescription: `款项将自动退回，无需卖家批准。`,
      deadlineDescriptionWithAmount: `{{amount}} 将自动退回，无需卖家批准。`,
      stepEmail: `确认邮件已发送到您的邮箱。`,
      stepMethod: `将按原支付方式全额退还。`,
      trackRefund: `查看退款进度`,
      backHome: `返回首页`,
    },
    confirmCancelRefund: {
      title: `您的退款正在处理中`,
      greeting: `您好，{{userFirstName}}！`,
      processingMessage: `我们已收到您对 {{productName}} 的退款申请并正在处理。金额 {{currentPrice}} 将在 24 个工作小时内退回。`,
      changedMindTitle: `改变主意了？`,
      changedMindDescription: `如果您想保留产品，可以在这里取消退款：`,
      keepPurchase: `保留我的购买`,
      orderDetailsTitle: `订单详情`,
      orderIdLabel: `ID：`,
      orderAmountLabel: `金额：`,
      supportMessage: `如果您对产品有疑问，请通过以下邮箱联系卖家支持：`,
      orCountOn: `或联系`,
      caktoSupport: `Cakto 支持`,
      snackbar: {
        success: `退款已成功取消`,
        error: `取消退款时出错`,
      },
    },
    howRefundsWork: {
      title: `退款如何运作？`,
      description: `我们的政策为所有购买提供 7 天自然日退款申请期。提交申请后，退款将在 24 小时内自动处理——卖家会收到通知并可在此期间与您联系，但退款不需要卖家批准。退款金额将按原支付方式全额退还。`,
    },
    modalTrySupport: {
      title: `需要帮助处理您的订单吗？`,
      descriptionLine1: `许多问题都可以通过联系卖家快速解决。`,
      descriptionLine2: `如果您愿意，可在继续退款前先联系支持：`,
      talkToSupport: `联系支持`,
      continueRefund: `继续退款`,
    },
    modalRefundBlocked: {
      title: `需要帮助处理您的订单吗？`,
      descriptionLine1: `我们希望为您提供最佳体验。`,
      descriptionLine2: `如您遇到技术问题或希望行使退款权利，请立即联系支持团队。`,
      talkToSupport: `联系支持`,
    },
    modalRefundInsufficientBalance: {
      title: `暂时无法申请退款`,
      description: `目前没有可用余额退还此订单的款项，因此您的退款申请未被提交。`,
      productSupport: `请通过以下邮箱联系产品客服：`,
      caktoSupportFallback: `如果问题仍未解决，请联系 Cakto 客服。`,
      caktoSupportOnly: `请联系 Cakto 客服了解后续处理方式。`,
      talkToProductSupport: `联系产品客服`,
      talkToCaktoSupport: `联系 Cakto 客服`,
      close: `关闭`,
    },
    purchaseCard: {
      productImageAlt: `产品`,
      fields: {
        amount: `金额：`,
        purchaseDate: `购买日期：`,
        refundDeadline: `申请退款截止日期：`,
        refundDeadlineShort: `退款截止：`,
        status: `状态：`,
        unknown: `未知`,
      },
      status: {
        processing: `处理中`,
        authorized: `已授权`,
        paid: `已支付`,
        refunded: `已退款`,
        waiting_payment: `待支付`,
        refused: `已拒绝`,
        chargedback: `退单/拒付`,
        canceled: `已取消`,
        in_protest: `争议中`,
        partially_paid: `部分支付`,
        refund_requested: `退款处理中`,
        acquirer_error: `退款未完成`,
        in_settlement: `退款处理中`,
        expired: `已过期`,
      },
      refundFailed: {
        title: `无法完成您的退款`,
        description: `卖家或其推广伙伴的余额不足，无法退还款项。请通过下方邮箱直接联系对方：`,
      },
      refundInProgress: {
        title: `退款处理中`,
        description: `款项将在 24 小时内按原支付方式退回。`,
      },
      refundSent: {
        title: `退款已提交至支付机构`,
        description: `该退款已无法取消。我们正在等待支付机构确认，款项到账时间取决于您的银行或发卡机构。`,
      },
      refundInReview: {
        title: `您的退款正在审核中`,
        description: `支付机构尚未确认退款，我们的团队正在核实。您无需重新申请。如需联系卖家，请使用下方邮箱：`,
      },
      requestRefund: `申请退款`,
      expiredRefund: `退款已过期`,
      refundBlocked: `退款已阻止`,
      cancelRefund: `取消退款`,
      snackbar: {
        notFound: `未找到退款申请`,
        expiredUpdating: `退款申请已过期，我们正在更新信息`,
      },
    },
    renderPurchaseCards: {
      empty: `未找到任何订单！`,
    },
  },
  contactPage: {
    pageTitle: {
      area: `页面`,
      screen: `联系我们`,
    },
    hero: {
      title: {
        where: `在哪里`,
        to: `可以`,
        find: `找到`,
        us: `我们？`,
      },
    },
    form: {
      titleLine1: `欢迎随时联系我们。`,
      titleLine2: `我们很高兴收到您的消息。`,
      name: `姓名`,
      email: `邮箱`,
      subject: `主题`,
      message: `请在此输入您的消息。`,
      submit: `立即提交`,
    },
    map: {
      address: `地址`,
    },
  },
};

export default cn;
